export function initPeriodiekAddPage() {
    const container = document.querySelector(".periodic-redemptions-add");
    if (!container) return;

    if (container.dataset.periodiekAddBound === "true") return;
    container.dataset.periodiekAddBound = "true";

    const form = container.querySelector("form[data-sds-form]");

    // Strip remote validation attributes to prevent JS errors.
    // The [Remote] attribute on NumberOfTimes points to a different controller and
    // causes a crash in jquery.validate.unobtrusive when placing errors.
    // Server-side validation on submit still catches invalid values.
    if (form) {
        form.querySelectorAll("[data-val-remote]").forEach((el) => {
            el.removeAttribute("data-val-remote");
            el.removeAttribute("data-val-remote-url");
            el.removeAttribute("data-val-remote-additionalfields");
        });

        // Re-parse the form validation without remote rules
        if (window.$ && window.$.validator && window.$.validator.unobtrusive) {
            // Ensure all validated inputs have matching data-valmsg-for placeholders
            form.querySelectorAll("[data-val='true']").forEach((input) => {
                if (!input.name) return;
                const escaped = input.name.replace(/([\\"'])/g, "\\$1");
                if (!form.querySelector('[data-valmsg-for="' + escaped + '"]')) {
                    const span = document.createElement("span");
                    span.setAttribute("data-valmsg-for", input.name);
                    span.setAttribute("data-valmsg-replace", "true");
                    span.classList.add("field-validation-valid");
                    input.insertAdjacentElement("afterend", span);
                }
            });

            const $form = window.$(form);
            $form.removeData("validator").removeData("unobtrusiveValidation");
            window.$.validator.unobtrusive.parse(form);
        }
    }

    const confirmCheckbox = container.querySelector('input[type="checkbox"]#Confirmed');
    const submitButton = container.querySelector('button[type="submit"]');

    const amountEl = container.querySelector("#Amount");
    const numberOfTimesEl = container.querySelector("#NumberOfTimes");
    const frequencyEl = container.querySelector("#Frequency");
    const startDateEl = container.querySelector("#StartDateString");

    function allFieldsFilled() {
        if (amountEl && !amountEl.value.trim()) return false;
        if (numberOfTimesEl && !numberOfTimesEl.value.trim()) return false;
        if (frequencyEl && !frequencyEl.value) return false;
        if (startDateEl && !startDateEl.value) return false;
        return true;
    }
    
    const months = [
        "januari", "februari", "maart", "april", "mei", "juni",
        "juli", "augustus", "september", "oktober", "november", "december"
    ];

    function recalcEndDate() {
        const endDateEl = container.querySelector("#endDate");
        if (!endDateEl) return;

        const frequency = frequencyEl ? frequencyEl.value : "";
        const numberOfTimes = numberOfTimesEl ? numberOfTimesEl.value : "";

        if (!frequency || !numberOfTimes || isNaN(parseInt(numberOfTimes))) {
            endDateEl.textContent = "n.v.t.";
            return;
        }

        const startDateString = startDateEl ? startDateEl.value : "";
        if (!startDateString) {
            endDateEl.textContent = "n.v.t.";
            return;
        }

        const d1 = new Date(startDateString);
        d1.setMonth(d1.getMonth() + (parseInt(frequency) * (parseInt(numberOfTimes) - 1)));

        endDateEl.textContent = months[d1.getMonth()] + " " + d1.getFullYear();
    }

    if (numberOfTimesEl) numberOfTimesEl.addEventListener("change", recalcEndDate);
    if (numberOfTimesEl) numberOfTimesEl.addEventListener("input", recalcEndDate);
    if (frequencyEl) frequencyEl.addEventListener("change", recalcEndDate);
    if (startDateEl) startDateEl.addEventListener("change", recalcEndDate);

    recalcEndDate();
}

